import NotFound from '../containers/not-found/index';
import authCookie from '../infrastructure/api/auth-cookie';

export const withPermission = permissions => children => {
  if (permissions.some(permission => authCookie.isAllowed(permission))) {
    return children;
  }
  return NotFound;
};
